<template>
  <v-app>
    <div class="invoice--container">
      <div class="header--action" v-if="$route.query.mobile !== 'true'">
        <div class="row align-center">
          <div class="col">{{ this.document ? this.document.invoice_number : 'Invoice' }}</div>
          <div class="col-auto">
            <button class="btn btn-primary btn-block" @click="print">
              {{ $t('invoice.print') }}
            </button>
          </div>
        </div>
      </div>
      <div
        class="container invoice-page pa-4 my-4"
        :style="{
          'margin-top': headerHeight + 'px',
        }"
      >
        <invoice v-if="$route.name === 'invoice'"></invoice>
      </div>
    </div>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
const Invoice = () => import('@/components/order/invoice');
import { decryptToken } from '@/utils/helpers';

export default {
  head() {
    return {
      title: this.document ? this.document.invoice_number : 'Invoice',
    };
  },
  async fetch({ store, params, route }) {
    // !! Get data invoice harus di fetch agar tetap muncul saat dibuka dari aplikasi !!
    let token = store.state.global.token;
    if (!store.state.global.loggedIn) {
      if (route.query.token) {
        token = decryptToken(route.query.token);
      }
    }
    await store.dispatch('order/getInvoice', {
      uuid: params.uuid,
      token: token,
    });
  },

  components: {
    Invoice,
  },
  computed: {
    ...mapState({
      headerHeight: (state) => state.size.headerHeight,
      document: (state) => state.order.invoice,
      isLoggedIn: (state) => state.global.loggedIn,
    }),
  },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>

<style lang="scss">
@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }

  .invoice--container {
    margin: 0 !important;
    padding: 6mm !important;
    overflow: visible !important;
  }

  .invoice-page {
    width: 1000px !important;
    max-width: none !important;
    margin: 0 auto !important;
    padding: 0 6px 0 0 !important;
    zoom: 0.76;
    transform: none !important;
    -webkit-transform: none !important;
    position: relative;
    left: -4px;
    box-sizing: border-box !important;
  }

  @supports not (zoom: 1) {
    .invoice-page {
      transform: scale(0.76) !important;
      -webkit-transform: scale(0.76) !important;
      transform-origin: top center !important;
      -webkit-transform-origin: top center !important;
    }
  }

  .invoice-page .invoice--wrapper {
    width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    break-inside: avoid;
    page-break-inside: avoid;
    overflow: hidden;
  }

  // Safari print tends to clip a few pixels on the right edge.
  @supports (-webkit-touch-callout: none) {
    .invoice-page {
      zoom: 0.75;
      padding: 0 12px 0 0 !important;
    }
  }
}
</style>
